import pastePlainTextHandler from '../../hdrm/handlers/paste-plain-text-handler';
import applyInsertion from '../helpers/apply-insertion';

const pasteHandler = (e) => {
  const contentEditable = e.srcElement.closest('[contenteditable]');
  const textHtmlData = e.clipboardData.getData('text/html');
  const canParseHtmlFromClipboard = Boolean(textHtmlData);

  if (!canParseHtmlFromClipboard) {
    pastePlainTextHandler(e);
    return;
  }

  e.preventDefault();

  applyInsertion(contentEditable, textHtmlData);
};

export default pasteHandler;
